/* global $, data, query_string */
import Table from 'bam-node-savant-table/table'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'cp'
let totalTitle = ''
let params
let header

$(document).ready(() => {
    // $('#ddlType').change(() => {
    //     $('#lblType').html($('#ddlType option:selected').text())
    // })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })

    $('#ddlTotal').change(() => {
        $('#lblTotal').html($('#ddlTotal option:selected').text())
        calculateTotals(data)
        params = createParams()
        // eslint-disable-next-line no-new
        new Table(params)
    })

    $('#ddlMin').change(() => {
        // $('#lblMin').html($('#Min').val());
        $('#lblMin').html(`Min Opportunities  (${$('#ddlMin').val()})`)
    })

    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html(`Min Opportunities  (${$('#ddlMin').val()})`)
    }

    // if (query_string.type) {
    //     $('#ddlType').val(query_string.type).attr('selected', true)
    //     $('#lblType').html($('#ddlType option:selected').text())
    // }

    if (query_string.total) {
        $('#ddlTotal').val(query_string.total).attr('selected', true)
        $('#lblTotal').html($('#ddlTotal option:selected').text())
    }

    if (query_string.year) {
        $('#ddlSeason').val(query_string.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason option:selected').text())
    }
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    $('form').submit(false)

    if (data && data.length > 0) {
        // eslint-disable-next-line no-global-assign
        data = calculateTotals(data)

        header = [
            {
                name: 'Player',
                field: 'href',
                customSortField: 'name_display_last_first',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'player_id',
            },
            {
                name: 'Team',
                field: 'name_abbrev',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
                photoOnly: true,
            },
        ]

        if (query_string.type) {
            if (query_string.type === 'team') {
                header = [
                    {
                        name: 'Team',
                        field: 'fld_name_display_club',
                        headerClass:
                            'th-component-header align-left table-static-column',
                        fieldClass: 'tr-data align-left table-static-column',
                        photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                        photoId: 'fld_team_id',
                    },
                ]
            }
            if (query_string.type === 'venue') {
                header = [
                    {
                        name: 'Venue',
                        field: 'venue_name',
                        headerClass:
                            'th-component-header align-left table-static-column',
                        fieldClass: 'tr-data align-left table-static-column',
                    },
                ]
            }
        }
        params = createParams()

        // eslint-disable-next-line no-new
        new Table(params)
    }

    $('#btnUpdate').click(() => {
        const url = populateUrl()
        window.location.href = url
    })
    $('#btnCSV').click(() => {
        const url = `${populateUrl()}&csv=true`
        window.location.href = url
    })

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function handleEach() {
                    // eslint-disable-next-line no-shadow
                    const width = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        width
                    )
                    tableCell += 1
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function handleEach() {
                    // eslint-disable-next-line no-shadow
                    const width = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        width
                    )
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    $(document).on('click', 'th.th-component-header', function handleClick() {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        const url = populateUrl()
        window.history.pushState('', '', url)
    })

    function populateUrl() {
        const url = `/leaderboard/catch_probability?type=player&min=${$(
            '#ddlMin'
        ).val()}&year=${$('#ddlSeason').val()}&total=${$(
            '#ddlTotal'
        ).val()}&sort=${$('#sort').val()}&sortDir=${$('#sortDir').val()}`
        return url
    }
})

function createParams() {
    let colspan = 4

    if (query_string.type && query_string.type === 'team') {
        colspan = 3
    }

    params = {
        id: 'cp',
        secondaryHeaders: [
            {
                name: '',
                colspan,
                headerClass: 'th-name-header',
            },
            {
                name: '',
                colspan: 1,
                headerClass: 'th-title-header',
            },
            {
                name: '5 Star (0-25%)',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: '4 Star (26-50%)',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: '3 Star (51-75%)',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: '2 Star (76-90%)',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: '1 Star (91-95%)',
                colspan: 3,
                headerClass: 'th-title-header',
            },
            {
                name: totalTitle,
                colspan: 3,
                headerClass: 'th-title-header',
            },
        ],
        headers: [
            {
                name: 'Total',
                field: 'n',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
            },
            {
                name: 'OAA',
                field: 'oaa',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data oaa',
                highlightDynamic: true,
            },
            {
                name: 'Outs',
                field: 'n_fieldout_5stars',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
            },
            {
                name: 'Opp',
                field: 'n_opp_5stars',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: '%',
                field: 'n_5star_percent',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
            },
            {
                name: 'Outs',
                field: 'n_fieldout_4stars',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data',
            },
            {
                name: 'Opp',
                field: 'n_opp_4stars',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: '%',
                field: 'n_4star_percent',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
            },
            {
                name: 'Outs',
                field: 'n_fieldout_3stars',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data',
            },
            {
                name: 'Opp',
                field: 'n_opp_3stars',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: '%',
                field: 'n_3star_percent',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
            },
            {
                name: 'Outs',
                field: 'n_fieldout_2stars',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data',
            },
            {
                name: 'Opp',
                field: 'n_opp_2stars',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: '%',
                field: 'n_2star_percent',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
            },
            {
                name: 'Outs',
                field: 'n_fieldout_1stars',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data',
            },
            {
                name: 'Opp',
                field: 'n_opp_1stars',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: '%',
                field: 'n_1star_percent',
                type: 'number',
                headerClass: 'th-component-header bolded-border-right',
                fieldClass: 'tr-data bolded-border-right',
            },
            {
                name: 'Outs',
                field: 'out_total',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data',
            },
            {
                name: 'Opp',
                field: 'opp_total',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: '%',
                field: 'total_percent',
                type: 'number',
                headerClass: 'th-component-header border-right',
                fieldClass: 'tr-data border-right',
            },
        ],
        data,
        showRank: true,
    }

    params.headers = header.concat(params.headers)
    params.defaultSort =
        params.headers[Number($('#sort').val())].customSortField ||
        params.headers[Number($('#sort').val())].field

    params.defaultSortDirection = $('#sortDir').val()
    params.sortClass = 'column-sort'

    const width = $(`#${tableDivId}`).outerWidth()
    params.repeatHeader = false
    if (width <= 768) {
        params.repeatHeader = 15
    }

    return params
}

function calculateTotals(data) {
    const totals = Number($('#ddlTotal').val())
    for (let i = 0; i < data.length; i++) {
        const d = data[i]

        d.opp_total = 0
        d.out_total = 0

        if (totals >= 1) {
            d.opp_total += Number(d.n_opp_5stars)
            d.out_total += Number(d.n_fieldout_5stars)
            totalTitle = '5+ Star Plays'
        }
        if (totals >= 2) {
            d.opp_total += Number(d.n_opp_4stars)
            d.out_total += Number(d.n_fieldout_4stars)
            totalTitle = '4+ Star Plays'
        }
        if (totals >= 3) {
            d.opp_total += Number(d.n_opp_3stars)
            d.out_total += Number(d.n_fieldout_3stars)
            totalTitle = '3+ Star Plays'
        }
        if (totals >= 4) {
            d.opp_total += Number(d.n_opp_2stars)
            d.out_total += Number(d.n_fieldout_2stars)
            totalTitle = '2+ Star Plays'
        }
        if (totals >= 5) {
            d.opp_total += Number(d.n_opp_1stars)
            d.out_total += Number(d.n_fieldout_1stars)
            totalTitle = '1+ Star Plays'
        }
        if (totals >= 6) {
            d.opp_total += Number(d.n_opp_0stars)
            d.out_total += Number(d.n_fieldout_0stars)
            totalTitle = 'All Plays'
        }

        d.total_percent = d.opp_total
            ? (Number(d.out_total / d.opp_total) * 100).toFixed(1)
            : null
    }

    return data
}
